import React from 'react';
import { useRevealAnimation } from '@/hooks/useRevealAnimation';

type Heading2Props = {
  children?: React.ReactNode;
  text?: string;
  id?: string;
  description?: string;
};

export const Heading2: React.FC<Heading2Props> = ({
  children,
  text,
  id,
  description,
}) => {
  const { ref, isVisible } = useRevealAnimation();

  return (
    <div className="mt-32 mb-12">
      <h2
        ref={ref}
        id={id}
        className={`font-montreal text-4xl mb-2 dark:text-white scroll-mt-24 transform transition-all duration-700 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
        }`}
      >
        {text ?? children}
      </h2>

      {description && (
        <p
          className={`text-lg text-zinc-700 dark:text-zinc-300 mt-2 mb-4 transform transition-all duration-700 delay-100 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
          }`}
        >
          {description}
        </p>
      )}

      <div
        className={`w-full h-px bg-zinc-200 dark:bg-zinc-800 transform transition-all duration-700 delay-200 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      />
    </div>
  );
};
